module.exports = __webpack_public_path__ + "img/story049@2x.53ca5c70.webp";